import React, { Component } from 'react'
import { 
    Button, Col, Container, Card, Row, Badge, Modal, 
    Form, Alert, Spinner
} from "react-bootstrap";
import { Navigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { getBooksAccess, updateBook, createBook } from '../../context/actions/index';
import {
    FaBook,
    FaPlus,
    FaEdit,
    FaStar,
    FaUsers,
    FaChartLine,
    FaArrowRight,
    FaCheckCircle
} from 'react-icons/fa';
import './Books.css';

class Books extends Component {
    constructor(props) {
        super(props);
        this.state = {
            book_id: '',
            name: '',
            desc: '',
            role: '',
            status: '',
            books: [],
            eligible: false,
            data: '',
            action: '',
            submitted: false,
            firstTime: false,
            done: false,
            navigate: false,
            show: false,
            edit: false,
            loading: true,
            error: null
        }
    }

    data = JSON.parse(localStorage["user-data"]);

    componentDidMount() {
        this.getBooks();
    }

    handleClose = () => this.setState({ 
        data: '', 
        show: false, 
        edit: false, 
        error: null, 
    });

    handleShow = (data = null, edit = false) => 
        this.setState({ 
            show: true, 
            data: data || {}, 
            edit: edit 
        });

    getBooks = async () => {
        try {
            this.setState({ loading: true, error: null });
            const book = await this.props.getBooksAccess(this.data.user_id);
            
            if (book.data && book.data.length > 0) {
                this.setState({
                    books: book.data,
                    id: book.data[0].id,
                    name: book.data[0].name,
                    desc: book.data[0].desc,
                    role: book.data[0].role,
                    status: book.data[0].status,
                    eligible: true,
                    loading: false
                });
            } else {
                this.setState({ 
                    firstTime: true, 
                    loading: false 
                });
            }
        } catch (error) {
            console.error("Error fetching books:", error);
            this.setState({ 
                error: "Gagal memuat data buku", 
                loading: false 
            });
        }
    }

    setAsDefault = async (bookId) => {
        try {
            localStorage.setItem("bookId", bookId);
            this.setState({ navigate: "/" });
        } catch (error) {
            console.error("Error setting default book:", error);
        }
    }

    BookCard = ({ book }) => {
        const isDefault = book.id === parseInt(localStorage.bookId);
        
        return (
            <Card className="book-card" onClick={() => this.handleShow(book, true)}>
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-start mb-3">
                        <div className="book-icon">
                            <FaBook />
                        </div>
                        <div>
                            {isDefault && (
                                <Badge bg="success" className="default-badge">
                                    <FaStar className="me-1" />
                                    Default
                                </Badge>
                            )}
                            <Badge bg="secondary" className="ms-1">
                                <FaUsers className="me-1" />
                                {book.role === 1 ? 'Pemilik' : 'Anggota'}
                            </Badge>
                        </div>
                    </div>
                    
                    <Card.Title className="book-title">{book.name}</Card.Title>
                    <Card.Text className="book-desc">{book.desc}</Card.Text>
                    
                    <div className="book-stats">
                        <small className="text-muted">
                            <FaChartLine className="me-1" />
                            Aktif
                        </small>
                    </div>
                </Card.Body>
                
                <Card.Footer className="book-actions">
                    <Button 
                        variant={isDefault ? "success" : "outline-success"} 
                        size="sm"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setAsDefault(book.id);
                        }}
                    >
                        {isDefault ? <FaCheckCircle /> : 'Set Default'}
                    </Button>
                    <Button 
                        variant="outline-primary" 
                        size="sm"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.handleShow(book, true);
                        }}
                    >
                        <FaEdit />
                    </Button>
                </Card.Footer>
            </Card>
        );
    }

    BooksGrid = () => {
        if (this.state.loading) {
            return (
                <div className="loading-container">
                    <Spinner animation="border" variant="primary" />
                    <p>Memuat buku...</p>
                </div>
            );
        }

        if (this.state.error) {
            return (
                <Alert variant="danger">
                    {this.state.error}
                </Alert>
            );
        }

        return (
            <Row>
                {this.state.books.map((book) => (
                    <Col key={book.id} lg={4} md={6} className="mb-4">
                        <this.BookCard book={book} />
                    </Col>
                ))}
            </Row>
        );
    }

    WelcomeModal = () => (
        <Modal
            show={this.state.firstTime}
            backdrop="static"
            keyboard={false}
            centered
            className="welcome-modal"
        >
            <Modal.Body className="text-center py-5">
                <div className="welcome-icon">
                    <FaBook />
                </div>
                <h4>Selamat Datang!</h4>
                <p className="text-muted">
                    Mari mulai dengan membuat buku pencatatan keuangan pertama Anda.
                </p>
                <Button 
                    variant="primary" 
                    onClick={() => this.setState({ navigate: "/books/create" })}
                    className="welcome-btn"
                >
                    <FaPlus className="me-2" />
                    Buat Buku Pertama
                </Button>
            </Modal.Body>
        </Modal>
    )

    render() {
        if (this.state.navigate) {
            return <Navigate to={this.state.navigate} />;
        }

        return (
            <div className="books-modern">
                <Container className="my-5">
                    <div className="books-header">
                        <h1 className="books-title">
                            <FaBook className="me-3" />
                            Buku Keuangan Saya
                        </h1>
                        <p className="books-subtitle">
                            Kelola semua buku pencatatan keuangan Anda di satu tempat
                        </p>
                        {/*
                        {this.state.eligible && (
                            
                            <Button 
                                variant="primary" 
                                onClick={() => this.handleShow()}
                                className="add-book-btn"
                            >
                                <FaPlus className="me-2" />
                                Tambah Buku Baru
                            </Button>
                            
                        )}
                        */}
                    </div>

                    {!this.state.eligible && !this.state.firstTime && (
                        <Card className="empty-state">
                            <Card.Body className="text-center py-5">
                                <FaBook className="empty-icon" />
                                <h5>Belum ada buku</h5>
                                <p className="text-muted mb-4">
                                    Mulai dengan membuat buku pencatatan keuangan pertama Anda
                                </p>
                                <Button 
                                    variant="primary"
                                    onClick={() => this.setState({ navigate: "/books/create" })}
                                >
                                    <FaPlus className="me-2" />
                                    Buat Buku Pertama
                                </Button>
                            </Card.Body>
                        </Card>
                    )}

                    {this.state.eligible && <this.BooksGrid />}

                    <this.WelcomeModal />
                    
                    <BookModal 
                        show={this.state.show}
                        onHide={this.handleClose}
                        data={this.state.data}
                        edit={this.state.edit}
                        createBook={this.props.createBook}
                        updateBook={this.props.updateBook}
                        refreshBooks={this.getBooks}
                    />
                </Container>
            </div>
        );
    }
}

// Book Modal Component
class BookModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.data?.name || '',
            desc: props.data?.desc || '',
            validated: false,
            loading: false,
            error: null,
            success: false
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data !== this.props.data) {
            this.setState({
                name: this.props.data?.name || '',
                desc: this.props.data?.desc || ''
            });
        }
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!this.state.name || !this.state.desc) {
            this.setState({ validated: true, error: "Harap lengkapi semua field" });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const bookData = {
                name: this.state.name,
                desc: this.state.desc,
                bookId:this.props.data.book_id,
                
            };
            console.log(bookData)
            if (this.props.edit) {
                await this.props.updateBook(bookData);
            } else {
                await this.props.createBook(bookData);
            }

            this.setState({ success: true });
            this.props.refreshBooks();
            
            setTimeout(() => {
                this.props.onHide();
                this.setState({loading:false, error: null, success:false})
            }, 1000);

        } catch (error) {
            console.error("Error saving book:", error);
            this.setState({ 
                error: "Gagal menyimpan buku. Silakan coba lagi.", 
                loading: false 
            });
        }
    }

    render() {
        const { show, onHide, edit } = this.props;

        return (
            <Modal show={show} onHide={onHide} centered className="book-modal">
                <Modal.Header closeButton>
                    <Modal.Title>
                        <FaBook className="me-2" />
                        {edit ? 'Edit Buku' : 'Buku Baru'}
                    </Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                    {this.state.error && (
                        <Alert variant="danger" dismissible>
                            {this.state.error}
                        </Alert>
                    )}
                    
                    {this.state.success && (
                        <Alert variant="success">
                            Buku berhasil {edit ? 'diperbarui' : 'dibuat'}!
                        </Alert>
                    )}

                    <Form onSubmit={this.handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nama Buku</Form.Label>
                            <Form.Control
                                type="text"
                                value={this.state.name}
                                onChange={(e) => this.setState({ name: e.target.value })}
                                placeholder="Contoh: Keuangan Keluarga, Usaha Toko, dll."
                                required
                                className="modern-input"
                            />
                        </Form.Group>

                        <Form.Group className="mb-4">
                            <Form.Label>Deskripsi</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                value={this.state.desc}
                                onChange={(e) => this.setState({ desc: e.target.value })}
                                placeholder="Deskripsi tujuan buku ini..."
                                required
                                className="modern-textarea"
                            />
                        </Form.Group>

                        <div className="modal-actions">
                            <Button 
                                variant="outline-secondary" 
                                onClick={onHide}
                                disabled={this.state.loading}
                            >
                                Batal
                            </Button>
                            <Button 
                                type="submit" 
                                variant="primary"
                                disabled={this.state.loading}
                            >
                                {this.state.loading ? (
                                    <>
                                        <Spinner animation="border" size="sm" className="me-2" />
                                        Menyimpan...
                                    </>
                                ) : (
                                    <>
                                        <FaBook className="me-2" />
                                        {edit ? 'Perbarui' : 'Simpan'} Buku
                                    </>
                                )}
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    user: state.user,
    books: state.books
});

const mapDispatchToProps = dispatch => ({
    getBooksAccess: (user) => dispatch(getBooksAccess(user)),
    updateBook: (book) => dispatch(updateBook(book)),
    createBook: (book) => dispatch(createBook(book)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Books);